/**
 * product-recommendations.js — Studio 1/1
 * ---------------------------------------------------------------------------
 * Product page "You might also like". sections/related-products.liquid
 * already server-renders real content on first paint — either genuine
 * Shopify recommendations (rare on a small/new store) or a same-type
 * fallback. This script only tries to *upgrade* that to real ML
 * recommendations in the background; it never hides the section or
 * clears content, since what's already there is always valid to show.
 *
 * Consumed hooks (see sections/related-products.liquid):
 *   [data-related-products]        section root
 *   [data-related-products-grid]   <ul>; data-source is "recommendations" or "fallback"
 */

(() => {
  'use strict';

  var section = document.querySelector('[data-related-products]');
  if (!section || !window.fetch) return;

  var grid = section.querySelector('[data-related-products-grid]');
  section.removeAttribute('aria-busy');

  // Already showing genuine recommendations (e.g. re-render) — nothing to upgrade.
  if (!grid || grid.dataset.source === 'recommendations') return;

  var productId = section.dataset.productId;
  var sectionId = section.dataset.sectionId;
  var limit = section.dataset.limit || 4;
  if (!productId || !sectionId) return;

  var url = '/recommendations/products?product_id=' + productId
    + '&limit=' + limit
    + '&intent=related'
    + '&section_id=' + sectionId;

  fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (res) { return res.ok ? res.text() : ''; })
    .then(function (html) {
      if (!html) return;

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-related-products-grid]');

      // Only swap in a genuine upgrade — leave the fallback in place otherwise.
      if (!newGrid || newGrid.dataset.source !== 'recommendations' || newGrid.children.length === 0) return;

      grid.innerHTML = newGrid.innerHTML;
      grid.dataset.source = 'recommendations';
    })
    .catch(function () {});
})();
